export default __webpack_public_path__ + "static/media/nftSearch.1d51c3a3.jpg";